(function () {
	'use strict';

	function ready() {
		return window.jQuery
			&& jQuery.fn
			&& typeof jQuery.fn.validate === 'function';
	}

	function failSafe(reason) {
		var forms = document.querySelectorAll('#pqf_wrap form');
		for (var i = 0; i < forms.length; i++) {
			forms[i].addEventListener('submit', function (e) {
				e.preventDefault();
			});
		}
		if (window.Sentry && typeof Sentry.captureMessage === 'function') {
			Sentry.captureMessage('pqf boot failed: ' + reason, 'error');
		}
	}

	function enableButtons() {
		var btns = document.querySelectorAll('#pqf_wrap .pqf-button');
		for (var i = 0; i < btns.length; i++) {
			btns[i].disabled = false;
		}
	}

	function load(src, done) {
		if (!src) return done(new Error('no src'));
		var s = document.createElement('script');
		s.src = src;
		s.onload = function () { done(null); };
		s.onerror = function () { done(new Error('load failed: ' + src)); };
		document.head.appendChild(s);
	}

	function boot() {

var cache = {};

if (powerQuoteForm.source_params) {
	if (powerQuoteForm.source_params.source_id && powerQuoteForm.source_params.partner_id) {
		cache.urlSourceId = powerQuoteForm.source_params.source_id;
		cache.urlPartnerId = powerQuoteForm.source_params.partner_id;
	}
}

jQuery(function ($) {
	'use strict';

	function getUrlParameter(name) {
		name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
		var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
		var results = regex.exec(location.search);
		return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
	}

	function getCookie(name) {
		var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
		return match ? decodeURIComponent(match[2]) : '';
	}

	function clearResumeCookie() {
		document.cookie = 'pqf_resume_plead_id=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
	}

	function shouldRenderSideImages() {
		return !window.matchMedia || window.matchMedia('(min-width: 768px)').matches;
	}

		var SIDE_IMAGE_FALLBACKS = {
		step1: 'Image-1-Desktop.webp',
		step2: 'Image-2-Desktop.webp',
		step3: 'Image-3-Desktop.webp',
		step4: 'Image-4-Desktop.webp'
		};

	function setZipConfirm(label) {
		$('#pqf_zip_confirm').text(label || '');
	}

		// Remembers the state abbreviation for each zip from the products lookup
	// label ("Mount Laurel, NJ"), so the address step can lock it.
	function rememberZipState(zip, label) {
		var parts = String(label || '').split(',');
		var state = $.trim(parts[parts.length - 1] || '').toUpperCase();
		zip = $.trim(zip || '');
		if (!zip || !/^[A-Z]{2}$/.test(state)) return;
		cache.zipStates = cache.zipStates || {};
		cache.zipStates[zip] = state;
	}

	// Locks the state field. A <select> can't be readonly and a disabled
	// one isn't posted, so a hidden input carries the value instead.
	function lockAddressState(state) {
		var $state = $('#pqf_state');
		$('#pqf_state_locked').remove();
		$state.prop('disabled', false).prop('readonly', false).removeClass('pqf-input--locked');
		if (!state || !$state.length) return;

		$state.val(state);
		// No matching option: leave it editable rather than post a blank state.
		if ($state.val() !== state) return;

		if ($state.is('select')) {
			$state.prop('disabled', true).attr('aria-disabled', 'true').addClass('pqf-input--locked');
			$('<input type="hidden" id="pqf_state_locked">')
				.attr('name', $state.attr('name') || 'state')
				.val(state)
				.insertAfter($state);
		} else {
			$state.prop('readonly', true).attr('aria-readonly', 'true').addClass('pqf-input--locked');
		}
	}

	// Products on page 1 were looked up for this zip, so the address
	// step must keep it (and its state). readonly so the zip still posts.
	function lockAddressZip() {
		var zip = cache.form1 && cache.form1.zip_code ? $.trim(cache.form1.zip_code) : '';
		$('#pqf_zip_code_1')
			.val(zip)
			.prop('readonly', true)
			.attr('aria-readonly', 'true')
			.addClass('pqf-input--locked');
		lockAddressState(cache.zipStates && cache.zipStates[zip]);
	}

	function getSideImageConfig(stepKey) {
		var assetsUrl = powerQuoteForm.assets_url || '/wp-content/plugins/power-quote-form/assets';
		var localized = powerQuoteForm.images && powerQuoteForm.images.side
			? powerQuoteForm.images.side[stepKey]
			: null;

		if (localized && localized.url) {
			return localized;
		}

		return {
			url: assetsUrl + '/images/side-imgs/' + (SIDE_IMAGE_FALLBACKS[stepKey] || SIDE_IMAGE_FALLBACKS.step1),
			width: 600,
			height: 1200,
			alt: '',
			srcset: '',
			sizes: ''
		};
	}

	function setSideImage(selector, stepKey, options) {
		var $sideImage = $(selector);
		if (!$sideImage.length) return;
		options = options || {};
		$sideImage.data('pqfSideImage', { stepKey: stepKey, options: options });

		if (!shouldRenderSideImages()) {
			$sideImage.empty().attr('hidden', true).hide();
			return;
		}

		var bgId = selector === '#side-img1' ? 'bg-img1' : 'bg-img';
		var image = getSideImageConfig(stepKey);
		var fetchPriority = options.fetchpriority ? ' fetchpriority="' + options.fetchpriority + '"' : '';
		var loading = options.loading || 'lazy';
		var decoding = options.decoding || 'async';
		var responsive = image.srcset
			? ' srcset="' + image.srcset + '" sizes="' + (image.sizes || '') + '"'
			: '';

		$sideImage
			.removeAttr('hidden')
			.html('<div id="' + bgId + '"><img src="' + image.url + '"' + responsive + fetchPriority +
				' loading="' + loading + '" decoding="' + decoding + '" alt="' + (image.alt || '') + '"' +
				' width="' + (image.width || 600) + '" height="' + (image.height || 1200) + '"></div>')
			.css('display', 'flex');
	}

	function refreshSideImagesForViewport() {
		$('#side-img, #side-img1').each(function () {
			var sideImage = $(this).data('pqfSideImage');
			if (!sideImage) return;
			setSideImage('#' + this.id, sideImage.stepKey, sideImage.options);
		});
	}

	function checkLeadStatusAndRoute(pleadId, onResolved) {
		onResolved(null);
	}

	function loadScheduleDataForRedirect() {
		setErrMsg(3);

		$('.pqf-page-3 .pqf-button').prop('disabled', true);

		var dataToSend = {
			action: 'power_get_schedule',
			pwrsec: powerQuoteForm.security[1]
		};

		if (cache.appointmentId) {
			dataToSend.appointment_id = cache.appointmentId;
		}
		if (cache.pleadId) {
			dataToSend.plead_id = cache.pleadId;
		}
		doAjax({
			url: powerQuoteForm.ajaxurl,
			data: dataToSend,
			type: 'POST',
		}, function (obj) {
			if (!obj.success) {
				setErrMsg(3, 0, 'Failed to load appointment availability. Please try again or contact support.');
				return;
			}

			var statusCode = obj.data[0];
			var responseBody = obj.data[1];

			if (statusCode === 204) {
				setErrMsg(3, '', 'No appointment availability found. Please contact support at 888-736-6335.');
				return;
			}
			if (statusCode === 404) {
				setErrMsg(
					3,
					'',
					'We couldn\u2019t find that address. Check for typos and try again, or call us at 888-736-6335 for help.'
				);

				$('.pqf-page-3 .pqf-button').prop('disabled', false);

				return;
			}
			if (statusCode === 500) {
				setErrMsg(3, '', 'Server error occurred. Please try again or contact support at 888-736-6335.');
				return;
			}

			if (statusCode !== 200) {
				setErrMsg(3, '', 'Unable to load appointment times (Error: ' + statusCode + '). Please contact support at 888-736-6335.');
				return;
			}

			if (!responseBody || responseBody.trim() === '') {
				setErrMsg(3, '', 'No appointment data received. Please contact support at 888-736-6335.');
				return;
			}

			var schedule;
			try {
				schedule = JSON.parse(responseBody);
			} catch (e) {
				setErrMsg(3, '', 'Invalid appointment data received. Please contact support at 888-736-6335.');
				return;
			}

			if (!schedule || !schedule.days || !schedule.timeSlots) {
				setErrMsg(3, '', 'Invalid appointment schedule format. Please contact support at 888-736-6335.');
				return;
			}

			cache.schedule = schedule;

			if (schedule.homeowner_info) {
				cache.redirectUserInfo = {
					first_name: schedule.homeowner_info.name || '',
					last_name: '',
					email: schedule.homeowner_info.email || '',
					phone_raw: schedule.homeowner_info.phone_number || '',
					street: schedule.homeowner_info.address1 || '',
					address2: schedule.homeowner_info.address2 || '',
					city: schedule.homeowner_info.city || '',
					state: schedule.homeowner_info.state || '',
					zip_code: schedule.homeowner_info.zipcode || ''
				};
			}

			var $list = $('#pqf_day_list').empty();
			$('#pqf_interval').html(schedule.period || 'Available Times');

			var currentMonth = new Date().getMonth();
			var currentYear = new Date().getFullYear();
			var arr = $.map(schedule.days, function (o, k) {
				o.key = k;
				o.month = toMonthNumber(o.formattedDate);
				o.year = o.month < currentMonth + 1 ? currentYear + 1 : currentYear;
				return o;
			}).sort(function (a, b) {
				if (a.year !== b.year) {
					return a.year - b.year;
				} else if (a.month !== b.month) {
					return a.month - b.month;
				} else {
					return a.monthDay - b.monthDay;
				}
			});

			if (arr.length === 0) {
				setErrMsg(3, '', 'No appointment slots available. Please contact support at 888-736-6335.');
				return;
			}

			$.each(arr, function (idx, v) {
				$list.append(buildDayHTML(idx, v));
			});

			var day = getDefaultScheduleDay(arr);
			cache.schedule.arrDays = arr;
			selectScheduleDay(day);

			scrollTop();
			initSlider();

		}, function (errMsg) {
			setErrMsg(3, '', 'Connection error: ' + errMsg + '. Please try again or contact support at 888-736-6335.');
		}, function () {
			$('.pqf-page-3 .pqf-button').prop('disabled', false);
		});
	}

	var validatorSchedule = $('#pqf_form_schedule').validate({
		rules: {
			day: {
				minlength: 1,
				atleastOne: true,
			},
			time: {
				minlength: 1,
				atleastOne: true,
			},
		},
		messages: {
			day: {
				atleastOne: 'Select one option',
			},
			time: {
				atleastOne: 'Select one option',
			},
		},

		submitHandler: function (form, event) {
			var day = $(':checked', '#pqf_day_list').val();
			var time = $(':checked', '#pqf_time_list').val();
			var date = getAPIDate(day);

			var formObj = {
				date: date,
				time: time,
				pwrsec: powerQuoteForm.security[1],
			};

			var resolvedPleadId = cache.appointmentId
				|| cache.pleadId
				|| (cache.form1 && cache.form1.plead_id)
				|| '';

			formObj.action = 'power_add_appointment';
			formObj.plead_id = resolvedPleadId;

			if (cache.redirectMode && cache.appointmentId) {
				formObj.appointment_id = cache.appointmentId;
			}

			if (!resolvedPleadId) {
				setErrMsg(3, '', 'We couldn\u2019t find your lead information. Please refresh the page and try again, or call us at 888-736-6335.');
				resetButtons(3);
				return false;
			}

			cache.form3 = formObj;
			setErrMsg(3);
			setLoadingButtons(3);

			doAjax({
				url: powerQuoteForm.ajaxurl,
				data: formObj,
				type: 'POST',
			}, function (obj) {
				var responseData = processPageResponse(obj, 3);

				if (responseData) {
					// GA4: appointment successfully booked - the
					// journey's final conversion (Form Success).
					pqfPushEvent('free_quote_schedule_estimate_submission', {
						form_step: 'booking_success',
						contact_path: 'schedule'
					});

					// Extract homeowner_info from appointment response if in redirect mode
					if (cache.redirectMode) {

						var statusCode = obj.data[0];
						var responseBody = obj.data[1];

						if (statusCode === 200 || statusCode === 201) {
							try {
								var appointmentData = JSON.parse(responseBody);

								if (appointmentData.homeowner_info) {
									var homeownerInfo = appointmentData.homeowner_info;
									cache.redirectUserInfo = {
										first_name: homeownerInfo.name || '',
										last_name: '',
										email: homeownerInfo.email || '',
										phone_raw: homeownerInfo.phone_number || '',
										street: homeownerInfo.address1 || '',
										address2: homeownerInfo.address2 || '',
										city: homeownerInfo.city || '',
										state: homeownerInfo.state || '',
										zip_code: homeownerInfo.zipcode || ''
									};
								}
							} catch (e) {}
						}
					}

					var fmtDt = '';
					var prevDay = day - 1;
					if (cache.schedule.days[prevDay] && isToday(prevDay)) {
						fmtDt = 'tomorrow, ';
					}
					fmtDt += cache.schedule.days[day].formattedDate;

					$('.pqf-page-5 .pqf-box__date').html(fmtDt + ' AT ' + to12HourFormat(time));

					var f, f2;

					if (cache.redirectMode && cache.redirectUserInfo) {
						f = cache.redirectUserInfo;
						f2 = cache.redirectUserInfo;
					} else {
						f = cache.form1;
						f2 = cache.form2;
					}


					setThankYouHeading($('.pqf-page-5'), f && f.first_name);


					if (f && f2) {
						// Build address display
						var fullName = f.first_name;
						if (f.last_name) {
							fullName += ' ' + f.last_name;
						}

						var addressLine = f2.street || '';
						if (f2.address2) {
							addressLine += ' ' + f2.address2;
						}
						if (f2.city) {
							addressLine += ' ' + f2.city;
						}

						var addressHTML = ucFirst(fullName) + '<br>' +
							(f.email ? f.email.toLowerCase() + '<br>' : '') +
							(f.phone_raw ? f.phone_raw + '<br>' : '') +
							ucFirst(addressLine);

						if (f2.state || f2.zip_code) {
							addressHTML += ', ' + (f2.state || '') + ' ' + (f2.zip_code || '');
						}

						$('address', '.pqf-page-5').html(addressHTML).show();
					} else {
						$('address', '.pqf-page-5').hide();
					}

					$('.pqf-page-3').hide();
					$('.pqf-page-5').show();
					setSideImage('#side-img1', 'step4');
					clearResumeCookie();
					scrollTop();
				}
			}, function (errMsg) {
				setErrMsg(3, 2, errMsg);
			}, function () {
				resetButtons(3);
			});

			return false;
		},
		invalidHandler: function (event, validator) {
			// GA4: no day/time selected on submit attempt.
			pqfTrackValidationError(validator.currentForm, validator);
			resetButtons(3);
		},
		onfocusout: function (element) {
			$(element).valid();
		},
	});

	function handleRedirectWorkflow() {
		var appointmentId = getUrlParameter('appointment_id');
		var pleadId = getUrlParameter('plead_id') || getCookie('pqf_resume_plead_id');

		if (appointmentId || pleadId) {
			$('.pqf-page-1').hide();
			$('.pqf-page-3').show();
			firePqfScheduleOnlineView();

			setSideImage('#side-img', 'step3');

			if (appointmentId) {
				cache.redirectMode = 'reschedule';
				cache.appointmentId = appointmentId;
			} else {
				cache.redirectMode = 'schedule';
				cache.pleadId = pleadId;
			}

			if (appointmentId) {
				setErrMsg(3, '', 'Loading your appointment details for rescheduling...');
			} else {
				setErrMsg(3, '', 'Loading available appointment times...');
			}
			setTimeout(function () {
				loadScheduleDataForRedirect();
			}, 100);

			return true;
		}
		return false;
	}

	function showScheduleError(message) {
		var errorHtml = '<div class="pqf-schedule-error" style="padding: 40px; text-align: center;">' +
			'<h3 style="color: #d32f2f; margin-bottom: 20px;">Unable to Load Appointment Times</h3>' +
			'<p style="margin-bottom: 20px;">' + message + '</p>' +
			'<div style="background: #f5f5f5; padding: 20px; border-radius: 5px; margin: 20px 0;">' +
			'<h4>Need Help?</h4>' +
			'<p>Call our scheduling team at <strong>888-736-6335</strong></p>' +
			'<p style="font-size: 14px; color: #666;">Press 1 at the prompt to speak with a POWER professional</p>' +
			'</div>' +
			'</div>';

		$('.pqf-page-3 form').hide();
		$('.pqf-page-3').append(errorHtml);
	}

	function setThankYouHeading($page, firstName) {
		var $header = $page.find('.pqf-header').first();
		var $heading = $header.find('h2.thank-you-heading');
		var $nameEl = $header.find('.thank-you-name');
		var name = firstName && String(firstName).trim();

		if (name) {
			$heading.html('THANK YOU,');
			$heading.addClass('thank-you-heading--has-name');
			$nameEl.text(name).prop('hidden', false);
		} else {
			$heading.html('THANK YOU');
			$heading.removeClass('thank-you-heading--has-name');
			$nameEl.empty().prop('hidden', true);
		}
	}

	function setErrMsg(pageId, msg, details) {
		var $errDiv = $('.pqf-error', '.pqf-page-' + pageId).empty();
		if (undefined === msg) return;

		if (pageId === 3 && cache.redirectMode && (msg !== undefined)) {
			if (typeof details === 'string' && details.includes('contact support')) {
				showScheduleError(details);
				return;
			}
		}

		msg = 'string' === typeof msg ? msg : errMsgs[msg];
		$errDiv.append($('<div>').html(msg));
		var details = details
			? ('string' === typeof details ? details : errMsgs[details])
			: '';
		if (details) {
			$errDiv.append($('<div>').append(details));
		} else {
			$errDiv.append($('<div>'));
		}
	}
	function setLoadingButtons(pageNum) {
		var $btns = $('.pqf-page-' + pageNum + ' .pqf-button');
		var $btn = $btns.eq(cache.clickedBtnId);
		$btn.addClass('loading');
		$btns.not($btn).prop('disabled', true);
	}

	function resetButtons(pageNum) {
		$('.pqf-page-' + pageNum + ' .pqf-button')
			.prop('disabled', false)
			.removeClass('loading');
	}

	/**
	 * Which page-1 CTA the visitor last used, as a GA4 contact_path value.
	 * Empty until one of them has been clicked.
	 */
	function pqfClickedContactPath() {
		if (undefined === cache.clickedBtnId) return '';
		return 0 === cache.clickedBtnId ? 'schedule' : 'request_call';
	}

	jQuery.validator.addMethod('atleastOne', function (value, element) {
		return $('input', $(element).parents('.pqf-input-list').first()).filter(':checked').length >= 1;
	}, 'Select at least one option.');

	jQuery.validator.addMethod('zipcode', function (value, element) {
		return isValidZipCode(value);
	}, 'Please enter a valid zip code.');

	jQuery.validator.addMethod('phone', function (value, element) {
		return isValidPhone(value);
	}, 'Please enter a valid 10 digit phone number.');

	jQuery.validator.addMethod('nospaces', function (value, element) {
		return value.replace(/\s/g, '').length > 0;
	}, 'This field is required.');

	const emojiRegex = /\p{Extended_Pictographic}/u;
	const EMOJI_FIELDS = '#pqf_first_name, #pqf_last_name, #pqf_email, #pqf_street, #pqf_city, ' +
		'#pqfm_first_name, #pqfm_last_name, #pqfm_email';

	function containsEmoji(value) {
		return emojiRegex.test(value);
	}

	jQuery.validator.addMethod('noemoji', function (value, element) {
		return this.optional(element) || !containsEmoji(value);
	}, 'Please enter only letters.');

	// Session cache of Kickbox successes. Same tab, same addresses skip
	// a second verify (keyup can clear the error instantly).
	var kickboxPassedEmails = {};
	function normalizeQuoteEmail(value) {
		return $.trim(value || '').toLowerCase();
	}
	function emailFromKickboxRequest(settings) {
		if (!settings) {
			return '';
		}
		var data = settings.data;
		if (data && 'string' !== typeof data) {
			return data.email || '';
		}
		// On GETs jQuery moves data into the URL and deletes it before
		// beforeSend runs, so the URL is the reliable source here.
		var match = String(data || settings.url || '').match(/(?:^|[?&])email=([^&]*)/);
		return match ? decodeURIComponent(match[1].replace(/\+/g, ' ')) : '';
	}
	function recheckEmailWithoutKickbox(element, validator) {
		if (element.name in validator.submitted || element.name in validator.invalid) {
			$(element).data('pqfSkipKickbox', true);
			validator.element(element);
			$(element).removeData('pqfSkipKickbox');
		}
	}

	// Every zip looked up so far this session, keyed by zip: the raw
	// power_get_products_html response (products markup, or 'no territory').
	// Shared by the page-1 form and the Request a Call modal, so a zip is
	// looked up once per session however many times and wherever it is
	// entered. Backed by sessionStorage so it survives a reload in the same
	// tab and is dropped when the tab closes. Nothing is kept for a failed
	// request, so the next try looks the zip up again.
	var ZIP_PRODUCTS_CACHE_KEY = 'pqf_zip_products_cache';

	var zipProductsCache = (function () {
		var stored = {};
		try {
			stored = JSON.parse(window.sessionStorage.getItem(ZIP_PRODUCTS_CACHE_KEY) || 'null') || {};
		} catch (e) {
			stored = {};
		}
		var clean = {};
		$.each(stored, function (zip, data) {
			if (isValidZipCode(zip) && 'string' === typeof data && data) {
				clean[zip] = data;
			}
		});
		return clean;
	})();

	function persistZipProductsCache() {
		try {
			window.sessionStorage.setItem(ZIP_PRODUCTS_CACHE_KEY, JSON.stringify(zipProductsCache));
		} catch (e) {
			// Storage unavailable (private mode, quota): the in-memory copy still works.
		}
	}

	function rememberZipProducts(zip, data) {
		zip = $.trim(zip || '');
		if (!isValidZipCode(zip) || 'string' !== typeof data || !data) return;
		if (-1 !== data.indexOf('pqf-error')) return;
		zipProductsCache[zip] = data;
		persistZipProductsCache();
	}

	function forgetZipProducts(zip) {
		zip = $.trim(zip || '');
		if (!zipProductsCache.hasOwnProperty(zip)) return;
		delete zipProductsCache[zip];
		persistZipProductsCache();
	}

	function zipFieldHasProducts() {
		return $('.pqf-products input').length > 0;
	}

	function restoreZipProductsIfNeeded() {
		var zip = $.trim($('#pqf_zip_code').val());
		if (!isValidZipCode(zip) || zipFieldHasProducts()) {
			return;
		}
		if ($('#pqf_no_coverage').is(':visible')) {
			return;
		}

		if (zipProductsCache.hasOwnProperty(zip)) {
			renderZipProducts(zip, zipProductsCache[zip]);
			if ('no territory' !== zipProductsCache[zip]) {
				$('.pqf-page-1.pqf-callout').show();
			}
			return;
		}

		doAjax({
			url: powerQuoteForm.ajaxurl,
			data: {
				action: 'power_get_products_html',
				zip_code: zip,
			},
			dataType: 'html',
		}, function (data) {
			if (-1 !== data.indexOf('pqf-error')) {
				return;
			}
			rememberZipProducts(zip, data);
			renderZipProducts(zip, data);
			if ('no territory' !== data) {
				$('.pqf-page-1.pqf-callout').show();
			}
		});
	}

	function renderZipProducts(zip, data, silent) {
		if ('no territory' === data) {
			if (!silent) {
				pqfPushEvent('free_quote_out_of_area', {
					form_step: 'details',
					service_area: 'out'
				});
			}
			$('.pqf-products-label').hide();
			$('.pqf-products').empty();
			showHideNoCovergeView(false);
			setZipConfirm('');
			cache.pqfZipRendered = zip;
			return;
		}

		if (!silent) {
			pqfPushEvent('free_quote_zip_validated', {
				form_step: 'details',
				service_area: 'in'
			});
		}

		var $html = $(data);
		var $location = $html.filter('.pqf-zip-location');
		if (!$location.length) {
			$location = $html.find('.pqf-zip-location');
		}
		var locationLabel = $location.data('label') || '';
		rememberZipState(zip, locationLabel);
		$html = $html.not('.pqf-zip-location');
		$('.pqf-products-label').show();
		$('.pqf-products').html($html);
		showHideNoCovergeView(true);
		setZipConfirm(locationLabel);
		cache.lastProductsDesc = locationLabel;
		cache.pqfZipRendered = zip;
	}

	function formIsOutOfArea(form) {
		if (form && 'pqfm_form_details' === form.id) {
			return $('#pqfm_no_coverage').is(':visible');
		}
		return $('#pqf_no_coverage').is(':visible');
	}
	function preventSubmitWhenOutOfArea(formId, coverageId) {
		$('#' + formId).on('submit.pqfOutOfArea', function (event) {
			if (!$('#' + coverageId).is(':visible')) {
				return;
			}
			event.preventDefault();
			event.stopImmediatePropagation();
		});
	}
	preventSubmitWhenOutOfArea('pqf_form_details', 'pqf_no_coverage');
	preventSubmitWhenOutOfArea('pqfm_form_details', 'pqfm_no_coverage');

	/* Zip lookups on their way, counted per form ('page1' or 'modal'). jQuery Validate only
	   reuses an answer that has already arrived, so without this a zip whose lookup is still
	   running would be sent again (the keyup timer, or a blur right after typing). The
	   running lookup answers for that zip, so the check waits for it instead. */
	var zipLookupsRunning = {};
	function zipLookupStart(jqXHR, opts) {
		if (!opts || !opts.url || -1 === opts.url.indexOf('power_get_products_html')) return;
		var zip = $.trim(new URL(opts.url, window.location.href).searchParams.get('zip_code') || '');
		if (!zip) return;
		var form = (opts.context && 'pqfm_form_details' === opts.context.id) ? 'modal' : 'page1';
		jqXHR.pqfZipLookup = form + ':' + zip;
		zipLookupsRunning[jqXHR.pqfZipLookup] = (zipLookupsRunning[jqXHR.pqfZipLookup] || 0) + 1;
	}
	function zipLookupEnd(jqXHR) {
		var key = jqXHR && jqXHR.pqfZipLookup;
		if (!key) return;
		jqXHR.pqfZipLookup = null;
		zipLookupsRunning[key] = Math.max(0, (zipLookupsRunning[key] || 0) - 1);
	}
	function zipLookupRunning(form, zip) {
		return (zipLookupsRunning[form + ':' + zip] || 0) > 0;
	}
	/* For blur/keyup: validate's element() aborts the running request for the field before it
	   checks, so a re-check for the zip already on its way is skipped here instead. */
	function zipFieldLookupRunning(element) {
		if (!element || 'zip_code' !== element.name) return false;
		var form = (element.form && 'pqfm_form_details' === element.form.id) ? 'modal' : 'page1';
		return zipLookupRunning(form, $.trim(element.value));
	}
	$(document).on('ajaxSend', function (e, jqXHR, opts) { zipLookupStart(jqXHR, opts); });
	$(document).on('ajaxComplete', function (e, jqXHR) { zipLookupEnd(jqXHR); });

	var validatorDetails = $('#pqf_form_details').validate({
		rules: {
			zip_code: {
				required: true,
				zipcode: true,
				remote: {
					depends: function (element) {
						var value = $.trim(element.value);
						if (!value) {
							return true;
						}
						// SSR products already match this zip; dataFilter would
						// discard the response anyway (isZipFilled).
						if (value === cache.pqfZipServerRendered) {
							return false;
						}
						if (zipProductsCache.hasOwnProperty(value)) {
							var cached = zipProductsCache[value];
							if (value !== cache.pqfZipRendered) {
								renderZipProducts(value, cached);
							} else if (
								'no territory' === cached &&
								!$('#pqf_no_coverage').is(':visible')
							) {
								renderZipProducts(value, cached);
							}
							return false;
						}
						return true;
					},
					param: {
						url: powerQuoteForm.ajaxurl,
						data: {
							action: 'power_get_products_html',
						},
						cache: false,
						dataType: 'html',
						beforeSend: function () {
							$('.pqf-page-1 .pqf-button').prop('disabled', true);
						},
						complete: function (jqXHR) {
							$('.pqf-page-1 .pqf-button').prop('disabled', false);
						},
						error: function (jqXHR, textStatus, errorThrown) {
							if ('abort' === textStatus) return;
							forgetZipProducts($('#pqf_zip_code').val());
							// GA4: transport-level failure (network/
							// server error) on the ZIP lookup itself, distinct
							// from a valid "no territory" response.
							pqfPushEvent('free_quote_form_error', {
								form_step: 'details',
								error_type: 'zip_lookup_failed'
							});
							var msg = 'AJAX failed  - ' + getAjaxFailReason(jqXHR, textStatus) + '<button class="pqf-button pqf-button-retry">Retry</button>';
							var pv = $('#pqf_zip_code').data('previousValue');
							showAjaxError('zip_code', msg, pv);
						},
						dataFilter: function (data, dataType) {
							if (isZipFilled) return true;
							var value = $.trim($('#pqf_zip_code').val());

							if (-1 !== data.indexOf('pqf-error')) {
								// GA4 : the products/territory lookup
								// itself failed server-side - an API error, not
								// a "your ZIP isn't in our service area" result.
								pqfPushEvent('free_quote_form_error', {
									form_step: 'details',
									error_type: 'zip_lookup_failed'
								});
								pqfReportQuoteFormError({
									form_step: 'details',
									error_type: 'zip_lookup_failed'
								});
								$('.pqf-products-label').hide();
								$('.pqf-products').empty();
								setZipConfirm('');
								cache.pqfZipRendered = '';
								forgetZipProducts(value);
								return 'Unexpected error occured.';
							}

							rememberZipProducts(value, data);
							renderZipProducts(value, data);
							return true;
						}
					}
				}
			},
			"products[]": {
				minlength: 1,
				atleastOne: true,
			},
			first_name: {
				required: true,
				nospaces: true,
				noemoji: true,
			},
			last_name: {
				required: true,
				nospaces: true,
				noemoji: true,
			},
			email: {
				required: true,
				email: true,
				noemoji: true,
				remote: {
					// depends makes jQuery Validation read the request
					// options from param, so they have to nest here.
					param: {
						url: powerQuoteForm.ajaxurl,
						data: {
							action: 'power_validate_email',
						},
						cache: false,
						beforeSend: function (jqXHR, settings) {
							$('.pqf-page-1 .pqf-button').prop('disabled', true);
							jqXHR.pqfEmail = emailFromKickboxRequest(settings);
						},
						complete: function (jqXHR, textStatus) {
							$('.pqf-page-1 .pqf-button').prop('disabled', false);
							if ('success' !== textStatus) {
								return;
							}
							if ('true' === jqXHR.responseJSON || true === jqXHR.responseJSON) {
								var verified = normalizeQuoteEmail(jqXHR.pqfEmail);
								if (verified) {
									kickboxPassedEmails[verified] = true;
								}
							}
						},
						error: function (jqXHR, textStatus, errorThrown) {
							if ('abort' === textStatus) return;
							// GA4: transport-level failure calling
							// Kickbox, distinct from Kickbox rejecting the
							// address (that's a form_validation_error, tracked
							// via invalidHandler below).
							pqfPushEvent('free_quote_form_error', {
								form_step: 'details',
								error_type: 'email_validation_failed'
							});
							var msg = 'AJAX failed  - ' + getAjaxFailReason(jqXHR, textStatus) + '<button class="pqf-button pqf-button-retry">Retry</button>';
							var pv = $('#pqf_email').data('previousValue');
							showAjaxError('email', msg, pv);
						},
					},
					depends: function (element) {
						if ($(element).data('pqfSkipKickbox')) {
							return false;
						}
						return !kickboxPassedEmails[normalizeQuoteEmail($(element).val())];
					},
				}
			},
			phone: {
				required: true,
				phone: true,
				remote: {
					url: powerQuoteForm.ajaxurl,
					data: {
						action: 'power_validate_phone',
					},
					cache: false,
					beforeSend: function () {
						$('.pqf-page-1 .pqf-button').prop('disabled', true);
					},
					complete: function (jqXHR) {
						$('.pqf-page-1 .pqf-button').prop('disabled', false);
					},
					error: function (jqXHR, textStatus, errorThrown) {
						if ('abort' === textStatus) return;
						var msg = 'AJAX failed  - ' + getAjaxFailReason(jqXHR, textStatus) + '<button class="pqf-button pqf-button-retry">Retry</button>';
						var pv = $('#pqf_phone').data('previousValue');
						showAjaxError('phone', msg, pv);
					},
				}
			},
			consent: {
				required: true,
			},
		},
		messages: {
			email: {
				email: function (params, element) {
					return containsEmoji($(element).val())
						? 'Please enter only letters.'
						: 'Please enter a valid email.';
				},
			},
			phone: {
				phone: 'Please enter a valid 10 digit phone number.',
			},
		},
		submitHandler: function (form, event) {
			if (formIsOutOfArea(form)) {
				return false;
			}

			var formObj = getFormObj(form && form.id ? form.id : 'pqf_form_details');
			// Which set of fields this lead came from: the page-1 form, or the
			// modal a failed "Request a Call" attempt sent the visitor to.
			var formVariant = pqfFormVariantForForm(form);
			formObj.action = 'power_add_lead';
			formObj.phone_raw = formObj.phone;
			formObj.phone = formObj.phone.replace(/\D/g, '');
			formObj.pwrsec = powerQuoteForm.security[0];
			formObj.call_later = 0 === cache.clickedBtnId ? 1 : 0;


			if (cache.urlSourceId && cache.urlPartnerId) {
				formObj.source_id = cache.urlSourceId;
				formObj.partner_id = cache.urlPartnerId;
			}
			cache.form1 = formObj;
			$('#scheduled_self_set').val(formObj.call_later);
			formObj.scheduled_self_set = formObj.call_later;


			setErrMsg(1);
			setLoadingButtons(1);

			doAjax({
				url: powerQuoteForm.ajaxurl,
				data: formObj,
				type: 'POST',
			}, function (obj) {

				if (!processPageResponse(obj, 1)) return;
				formObj.plead_id = obj.data[2];
				cache.form1.plead_id = obj.data[2];

				// GA4 : lead created successfully - fires on
				// either contact path, including the duplicate-lead reuse
				// branch just below, since power_add_lead already
				// succeeded by this point either way.
				var pqfContactPath = 0 === cache.clickedBtnId ? 'schedule' : 'request_call';
				pqfPushEvent('free_quote_form_submission', {
					form_step: 'details',
					contact_path: pqfContactPath,
					form_variant: formVariant
				});
				pqfPushEvent('generate_lead', {
					form_step: 'details',
					contact_path: pqfContactPath,
					form_variant: formVariant
				});

				if (obj.data[5] === 'duplicate_continue' && obj.data[3]) {
					var schedule = processPageResponse({ success: true, data: obj.data[3] }, 2, 200, 'schedule');
					if (!schedule) return;

					cache.schedule = schedule;
					cache.redirectMode = 'schedule';
					cache.pleadId = obj.data[2];

					var $list = $('#pqf_day_list').empty();
					$('#pqf_interval').html(schedule.period || 'Available Times');

					var currentMonth = new Date().getMonth();
					var currentYear = new Date().getFullYear();
					var arr = $.map(schedule.days, function (o, k) {
						o.key = k;
						o.month = toMonthNumber(o.formattedDate);
						o.year = o.month < currentMonth + 1 ? currentYear + 1 : currentYear;
						return o;
					}).sort(function (a, b) {
						if (a.year !== b.year) return a.year - b.year;
						if (a.month !== b.month) return a.month - b.month;
						return a.monthDay - b.monthDay;
					});

					$.each(arr, function (idx, v) {
						$list.append(buildDayHTML(idx, v));
					});
					cache.schedule.arrDays = arr;
					setTimeSlots(arr[0].key);
					$list.data('day', '');

					setSideImage('#side-img', 'step3');
					$('.pqf-page-1').hide();
					$('.pqf-page-3').show();
					firePqfScheduleOnlineView();
					scrollTop();
					initSlider();
					return;
				}

				if (0 === cache.clickedBtnId) {
					lockAddressZip();
					setErrMsg(2);
					setSideImage('#side-img', 'step2');
					$('.pqf-page-1').hide();
					$('.pqf-page-2').show();
					loadAddressAutocomplete(initAddressAutoComplete);
				} else {
					setThankYouHeading($('.pqf-page-4'), cache.form1 && cache.form1.first_name);
					var srcId = Number(obj.data[4]);


					if (24447 === srcId) {
						$('#pqf-helpline', '.pqf-page-4').attr('href', 'tel:888-309-1207').html('(888) 309-1207');
					} else if (24442 === srcId) {
						$('#pqf-helpline', '.pqf-page-4').attr('href', 'tel:888-279-1261').html('(888) 279-1261');
					} else if (24452 === srcId) {
						$('#pqf-helpline', '.pqf-page-4').attr('href', 'tel:888-427-1086').html('(888) 427-1086');
					} else if (24457 === srcId) {
						$('#pqf-helpline', '.pqf-page-4').attr('href', 'tel:888-964-1215').html('(888) 964-1215');
					} else if (28060 === srcId) {
						$('#pqf-helpline', '.pqf-page-4').attr('href', 'tel:888-697-4068').html('(888) 697-4068');
					}
					$('.pqf-page-1').hide();
					$('.pqf-page-4').show();

					// GA4 : callback path, no appointment - the
					// journey ends here unless the visitor later opts back
					// into scheduling from this thank-you screen.
					pqfPushEvent('free_quote_request_call', {
						form_step: 'thank_you',
						contact_path: 'request_call',
						form_variant: formVariant
					});

					if ('inline' === formVariant) {
						pqfPushEvent('free_quote_request_call_completed_form', {
							form_step: 'thank_you',
							contact_path: 'request_call'
						});
					}
				}
				scrollTop();
			}, function (errMsg) {
				setErrMsg(1, 2, errMsg);
			}, function () {
				resetButtons(1);
				// No-op unless this submit came from the modal, which waits
				// on the response before getting out of the way. On a failure
				// that also uncovers the error this just wrote to page 1.
				pqfmClose();
			});

			return false;
		},
		invalidHandler: function (event, validator) {
			resetButtons(1);

			// "Request a Call" (idx 1) diverts to the modal on a failed
			// attempt. Schedule Online keeps the inline errors it has always
			// shown, and a valid submit goes to submitHandler instead of here.
			//
			// The visitor never sees these inline errors on the callback path,
			// so no validation-error event fires for them - pqfmOpen() pushes
			// the modal-open event, and the invalid-form signal for this path
			// comes from the modal's own submit.
			if (1 === cache.clickedBtnId) {
				pqfmOpen();
				return;
			}

			// GA4 : client-side field validation failed on
			// submit (required field, bad phone/zip format, Kickbox
			// rejection, etc).
			pqfTrackValidationError(validator.currentForm, validator, pqfClickedContactPath());
		},
		onfocusout: function (element) {
			if (zipFieldLookupRunning(element)) return;
			$(element).valid();
		},
		// Email: local format on input (below). Kickbox only on blur/submit
		// unless this address already passed in this tab.
		onkeyup: function (element, event) {
			if ('pqf_email' === element.id) {
				return;
			}
			if (zipFieldLookupRunning(element)) return;
			$.validator.defaults.onkeyup.call(this, element, event);
		},
	});

	$('#pqf_email').on('input', function () {
		recheckEmailWithoutKickbox(this, validatorDetails);
	});

	var validatorAddress = $('#pqf_form_address').validate({
		rules: {
			zip_code: {
				required: true,
				zipcode: true,
			},
			street: {
				required: true,
				nospaces: true,
				noemoji: true,
			},
			city: {
				required: true,
				nospaces: true,
				noemoji: true,
			},
			state: {
				required: true,
			},
			owner: {
				required: true,
			},
		},
		messages: {
		},
		submitHandler: function (form, event) {

			var formObj = getFormObj('pqf_form_address');
				if (cache.form1 && cache.form1.zip_code) {
				formObj.zip_code = cache.form1.zip_code;
				var lockedState = cache.zipStates && cache.zipStates[$.trim(cache.form1.zip_code)];
				if (lockedState) {
					formObj.state = lockedState;
				}
			}
			formObj.pwrsec = powerQuoteForm.security[0];
			cache.form2 = formObj;

			setErrMsg(2);
			setLoadingButtons(2);

			var mergedData = __assign(cache.form1, formObj);

			doAjax({
				url: powerQuoteForm.ajaxurl,
				data: mergedData,
				type: 'POST',
			}, function (obj) {

				// Existing active Nitro lead: continue directly to scheduling.
				if (
					obj.success &&
					obj.data &&
					obj.data[5] === 'duplicate_continue' &&
					obj.data[2]
				) {
					cache.pleadId = obj.data[2];
					cache.form1.plead_id = obj.data[2];
					cache.redirectMode = 'schedule';

					// GA4 : address step accepted (reusing an
					// existing active lead), continuing into scheduling.
					pqfPushEvent('free_quote_save_continue', {
						form_step: 'address',
						contact_path: 'schedule'
					});

					var scheduleResponse = obj.data[3];

					if (!scheduleResponse) {
						setErrMsg(
							2,
							'',
							'Unable to load available appointment times. Please try again.'
						);
						return;
					}

					var schedule = processPageResponse(
						{
							success: true,
							data: scheduleResponse
						},
						2,
						200,
						'schedule'
					);

					if (!schedule) return;

					cache.schedule = schedule;

					var $list = $('#pqf_day_list').empty();

					$('#pqf_interval').html(
						schedule.period || 'Available Times'
					);

					var currentMonth = new Date().getMonth();
					var currentYear = new Date().getFullYear();

					var arr = $.map(schedule.days, function (o, k) {
						o.key = k;
						o.month = toMonthNumber(o.formattedDate);
						o.year = o.month < currentMonth + 1
							? currentYear + 1
							: currentYear;

						return o;
					}).sort(function (a, b) {
						if (a.year !== b.year) {
							return a.year - b.year;
						}

						if (a.month !== b.month) {
							return a.month - b.month;
						}

						return a.monthDay - b.monthDay;
					});

					$.each(arr, function (idx, v) {
						$list.append(buildDayHTML(idx, v));
					});

					cache.schedule.arrDays = arr;

					if (arr.length) {
						var day = getDefaultScheduleDay(arr);
						selectScheduleDay(day);
					}

					$list.data('day', '');

					setErrMsg(3);
					setSideImage('#side-img', 'step3');

					$('.pqf-page-2').hide();
					$('.pqf-page-3').show();
					firePqfScheduleOnlineView();

					scrollTop();
					initSlider();

					return;
				}

				// Existing behavior for all other responses.
				if (!processPageResponse(obj, 2)) return;

				// GA4 : address step submitted successfully -
				// this fires as soon as the primary lead/address API call
				// succeeds, even if the embedded schedule lookup just
				// below then fails (that failure is tracked separately as
				// free_quote_form_error / address_not_found).
				pqfPushEvent('free_quote_save_continue', {
					form_step: 'address',
					contact_path: 'schedule'
				});

				var scheduleResponse = obj.data[3];

				if (scheduleResponse && scheduleResponse[0] === 404) {
					setErrMsg(
						2,
						'',
						'We couldn\u2019t find that address. Check for typos and try again, or call us at 888-736-6335 for help.'
					);

					$('.pqf-page-2 .pqf-button').prop('disabled', false);
					return;
				}

				var schedule = processPageResponse(
					{
						success: true,
						data: scheduleResponse
					},
					2,
					200,
					'schedule'
				);

				if (!schedule) return;

				cache.schedule = schedule;

				var $list = $('#pqf_day_list').empty();

				$('#pqf_interval').html(schedule.period);

				var currentMonth = new Date().getMonth();
				var currentYear = new Date().getFullYear();

				var arr = $.map(schedule.days, function (o, k) {
					o.key = k;
					o.month = toMonthNumber(o.formattedDate);
					o.year = o.month < currentMonth + 1
						? currentYear + 1
						: currentYear;

					return o;
				}).sort(function (a, b) {
					if (a.year !== b.year) {
						return a.year - b.year;
					} else if (a.month !== b.month) {
						return a.month - b.month;
					} else {
						return a.monthDay - b.monthDay;
					}
				});

				$.each(arr, function (idx, v) {
					$list.append(buildDayHTML(idx, v));
				});

				var day = getDefaultScheduleDay(arr);

				cache.schedule.arrDays = arr;
				selectScheduleDay(day);

				setErrMsg(3);
				setSideImage('#side-img', 'step3');

				$('.pqf-page-2').hide();
				$('.pqf-page-3').show();
				firePqfScheduleOnlineView();

				scrollTop();
				initSlider();

			}, function (errMsg) {
				setErrMsg(2, 2, errMsg);
			}, function () {
				resetButtons(2);
			});

			return false;
		},
		invalidHandler: function (event, validator) {
			// GA4 : client-side field validation failed
			// (street/city/state/zip/owner) on submit.
			pqfTrackValidationError(validator.currentForm, validator);
			resetButtons(2);
		},
		onfocusout: function (element) {
			$(element).valid();
		},
	});

	/*--- "Request a Call" modal ---
	 * Opened from the details form's invalidHandler when the visitor chooses
	 * "Request a Call" while something is still invalid. The modal runs its
	 * own validator over a copy of the details fields, then posts the
	 * same power_add_lead request from those fields.
	 */

	var PQFM_FOCUSABLE = [
		'a[href]',
		'button:not([disabled])',
		'input:not([disabled]):not([type="hidden"])',
		'select:not([disabled])',
		'textarea:not([disabled])',
		'[tabindex]:not([tabindex="-1"])'
	].join(',');

	function pqfmIsOpen() {
		var $modal = $('#pqfm_modal');
		return $modal.length && !$modal.prop('hidden');
	}

	function pqfmSetButtonsDisabled(disabled) {
		$('.pqfm-actions .pqf-button').prop('disabled', disabled);
	}

	/**
	 * Shows or hides everything below the zip field, mirroring what
	 * showHideNoCovergeView() does for the inline form. The products label is
	 * left alone because the zip lookup below owns it.
	 */
	function pqfmShowCoverage(hasCoverage) {
		$('#pqfm_form_details > .row').not('.pqfm-products-label').toggle(!!hasCoverage);
		$('#pqfm_no_coverage').toggle(!hasCoverage);
	}

	function pqfmZipDesc() {
		return $('#pqfm_zip_code ~ .pqf-field__desc');
	}

	function pqfmSetZipResult(zip) {
		pqfmZipDesc().text('Products available in ' + zip);
		cache.pqfmZipShown = zip;
	}

	function renderPqfmZipProducts(zip, data) {
		if ('no territory' === data) {
			pqfPushEvent('free_quote_out_of_area', {
				form_step: 'details',
				service_area: 'out'
			});
			$('.pqfm-products-label').hide();
			$('.pqfm-products').empty();
			pqfmZipDesc().empty();
			cache.pqfmZipShown = '';
			pqfmShowCoverage(false);
			cache.pqfmZipRendered = zip;
			return;
		}

		pqfPushEvent('free_quote_zip_validated', {
			form_step: 'details',
			service_area: 'in'
		});
		$('.pqfm-products').html(data.replace(/id="pqf_product_/g, 'id="pqfm_product_'));
		$('.pqfm-products-label').show();
		pqfmSetZipResult(zip);
		pqfmShowCoverage(true);
		cache.pqfmZipRendered = zip;
	}

	function pqfmClearZipResult() {
		cache.pqfmZipShown = '';
		cache.pqfmZipRendered = '';
		pqfmZipDesc().empty();
		$('.pqfm-products').empty();
		$('.pqfm-products-label').hide();
		pqfmShowCoverage(true);
	}

	function pqfmResetZip() {
		pqfmClearZipResult();

		$('#pqfm_zip_code')
			.val('')
			.removeData('previousValue')
			.removeClass('error')
			.removeAttr('aria-invalid');
		$('#pqfm_zip_code-error').empty().hide();
	}

	/**
	 * Copies the inline form's product checkboxes into the modal
	 **/
	function pqfmSyncProducts() {
		var $source = $('.pqf-products');
		var $target = $('.pqfm-products');
		if (!$source.length || !$target.length) return;

		$target.html($source.html().replace(/id="pqf_product_/g, 'id="pqfm_product_'));
		$('.pqfm-products-label').toggle($target.find('input').length > 0);
	}

	function pqfmFocusable() {
		return $('#pqfm_modal').find(PQFM_FOCUSABLE).filter(':visible');
	}

	function pqfmPrefill() {
		var $target = $('#pqfm_form_details');

		$('#pqf_form_details').find('input, select, textarea').each(function () {
			var source = this;
			if (!source.name || 'hidden' === source.type) return;

			var $fields = $target.find('[name="' + source.name + '"]');
			if (!$fields.length) return;

			if ('checkbox' === source.type || 'radio' === source.type) {
				$fields.filter(function () {
					return this.value === source.value;
				}).prop('checked', source.checked);
				return;
			}

			$fields.val($(source).val());
		});
	}

	function pqfmClearDetailsErrors() {
		if (!validatorDetails) return;

		validatorDetails.invalid = {};
		validatorDetails.submitted = {};
		validatorDetails.prepareForm();
		validatorDetails.hideErrors();
		validatorDetails.resetElements(
			validatorDetails.elements().removeAttr('aria-invalid')
		);
	}

	function pqfmClearErrors() {
		if (!validatorModal) return;

		validatorModal.invalid = {};
		validatorModal.submitted = {};
		validatorModal.prepareForm();
		validatorModal.hideErrors();
		validatorModal.resetElements(
			validatorModal.elements().removeAttr('aria-invalid')
		);
	}

	function pqfmOpen() {
		var $modal = $('#pqfm_modal');
		if (!$modal.length || pqfmIsOpen()) return;

		cache.pqfmReturnFocus = document.activeElement;

		$modal.prop('hidden', false);
		$('body').addClass('pqfm-modal-open');

		pqfmResetZip();
		pqfmClearErrors();
		pqfmSyncProducts();
		pqfmPrefill();

		pqfPushEvent('free_quote_request_call_modal_open', {
			form_step: 'details',
			contact_path: 'request_call',
			form_variant: 'modal'
		});

		var pqfmZip = $.trim($('#pqfm_zip_code').val());
		if (pqfmZip) {
			if ($('.pqfm-products input').length) {
				pqfmSetZipResult(pqfmZip);
			} else {
				validatorModal.element('#pqfm_zip_code');
			}
		}

		setTimeout(function () {
			if (!pqfmIsOpen()) return;

			pqfmClearDetailsErrors();

			var $first = pqfmFocusable().not('[data-pqfm-close]').first();
			if (!$first.length) $first = pqfmFocusable().first();
			$first.trigger('focus');
		}, 0);
	}

	/* The zip checked in the modal is shown on page 1 too: as soon as the modal has its
	   answer, and again when the modal closes. The answer comes from the session cache
	   (the modal stored it when it looked the zip up), so page 1 makes no request of its
	   own. Only while page 1 is still showing: after a lead is created the thank-you page
	   has it. The render is silent, the modal already sent the GA events for this lookup. */
	function pqfmMirrorZipToPage1(zip) {
		if (!isValidZipCode(zip) || !zipProductsCache.hasOwnProperty(zip)) return;
		if (!$('.pqf-page-1').not('.pqf-callout').first().is(':visible')) return;

		var $zip = $('#pqf_zip_code');
		if ($.trim($zip.val()) === zip && zip === cache.pqfZipRendered) return;

		$zip.val(zip);
		isZipFilled = false;
		renderZipProducts(zip, zipProductsCache[zip], true);
		// Re-validates the field so an error left from the submit attempt
		// that opened the modal is cleared. depends() sees the zip is
		// already rendered from the cache and sends nothing.
		validatorDetails.element($zip[0]);
	}

	function pqfmSyncZipToPage1() {
		pqfmMirrorZipToPage1($.trim($('#pqfm_zip_code').val()));
	}

	function pqfmClose() {
		if (!pqfmIsOpen()) return;

		$('#pqfm-submit').removeClass('loading');

		pqfmSyncZipToPage1();
		pqfmResetZip();
		pqfmClearErrors();

		$('#pqfm_modal').prop('hidden', true);
		$('body').removeClass('pqfm-modal-open');

		var returnTo = cache.pqfmReturnFocus;
		cache.pqfmReturnFocus = null;
		if (returnTo && returnTo.focus) returnTo.focus();
	}

	function pqfmHandleTab(e) {
		var $items = pqfmFocusable();
		if (!$items.length) return;

		var first = $items[0];
		var last = $items[$items.length - 1];
		var active = document.activeElement;

		if (e.shiftKey && (active === first || !$.contains($('#pqfm_modal')[0], active))) {
			e.preventDefault();
			last.focus();
		} else if (!e.shiftKey && active === last) {
			e.preventDefault();
			first.focus();
		}
	}

	var validatorModal = $('#pqfm_form_details').validate({
		rules: {
			zip_code: {
				required: true,
				zipcode: true,
				remote: {
					depends: function (element) {
						var value = $.trim(element.value);
						if (!value) {
							return true;
						}
						if (zipProductsCache.hasOwnProperty(value)) {
							var cached = zipProductsCache[value];
							if (value !== cache.pqfmZipRendered) {
								renderPqfmZipProducts(value, cached);
							} else if (
								'no territory' === cached &&
								!$('#pqfm_no_coverage').is(':visible')
							) {
								renderPqfmZipProducts(value, cached);
							}
							return false;
						}
						return true;
					},
					param: {
						url: powerQuoteForm.ajaxurl,
						data: {
							action: 'power_get_products_html',
						},
						cache: false,
						dataType: 'html',
						beforeSend: function () {
							pqfmSetButtonsDisabled(true);
						},
						complete: function () {
							pqfmSetButtonsDisabled(false);
						},
						error: function (jqXHR, textStatus) {
							if ('abort' === textStatus) return;
							forgetZipProducts($('#pqfm_zip_code').val());
							pqfPushEvent('free_quote_form_error', {
								form_step: 'details',
								error_type: 'zip_lookup_failed'
							});
							pqfReportQuoteFormError({
								form_step: 'details',
								error_type: 'zip_lookup_failed'
							});
							pqfmClearZipResult();
						},
						dataFilter: function (data) {
							var value = $.trim($('#pqfm_zip_code').val());

							if (-1 !== data.indexOf('pqf-error')) {
								pqfPushEvent('free_quote_form_error', {
									form_step: 'details',
									error_type: 'zip_lookup_failed'
								});
								pqfReportQuoteFormError({
									form_step: 'details',
									error_type: 'zip_lookup_failed'
								});
								cache.pqfmZipRendered = '';
								forgetZipProducts(value);
								pqfmClearZipResult();
								return 'Unexpected error occured.';
							}

							// Keep the answer for the rest of the session so this
							// zip is served from cache next time, here or on page 1
							// (the depends() above). The inline form already did
							// this; the modal only rendered and never stored.
							rememberZipProducts(value, data);

							if ('no territory' === data) {
								pqfPushEvent('free_quote_out_of_area', {
									form_step: 'details',
									service_area: 'out'
								});
								pqfmClearZipResult();
								pqfmShowCoverage(false);
								pqfmMirrorZipToPage1(value);
								return true;
							}
							rememberZipState(
								$('#pqfm_zip_code').val(),
								$('<div>').html(data).find('.pqf-zip-location').data('label')
							);
							$('.pqfm-products').html(data.replace(/id="pqf_product_/g, 'id="pqfm_product_'));
							$('.pqfm-products-label').show();
							pqfmSetZipResult($('#pqfm_zip_code').val());
							pqfmShowCoverage(true);
							pqfmMirrorZipToPage1(value);
							return true;
						}
					}
				}
			},
			"products[]": {
				minlength: 1,
				atleastOne: true,
			},
			first_name: {
				required: true,
				nospaces: true,
				noemoji: true,
			},
			last_name: {
				required: true,
				nospaces: true,
				noemoji: true,
			},
			email: {
				required: true,
				email: true,
				noemoji: true,
				remote: {
					// depends makes jQuery Validation read the request
					// options from param, so they have to nest here.
					param: {
						url: powerQuoteForm.ajaxurl,
						data: {
							action: 'power_validate_email',
						},
						cache: false,
						beforeSend: function (jqXHR, settings) {
							pqfmSetButtonsDisabled(true);
							jqXHR.pqfEmail = emailFromKickboxRequest(settings);
						},
						complete: function (jqXHR, textStatus) {
							pqfmSetButtonsDisabled(false);
							if ('success' !== textStatus) {
								return;
							}
							if ('true' === jqXHR.responseJSON || true === jqXHR.responseJSON) {
								var verified = normalizeQuoteEmail(jqXHR.pqfEmail);
								if (verified) {
									kickboxPassedEmails[verified] = true;
								}
							}
						},
						error: function (jqXHR, textStatus) {
							if ('abort' === textStatus) return;
							pqfPushEvent('free_quote_form_error', {
								form_step: 'details',
								error_type: 'email_validation_failed'
							});
							pqfReportQuoteFormError({
								form_step: 'details',
								error_type: 'email_validation_failed'
							});
						},
					},
					depends: function (element) {
						if ($(element).data('pqfSkipKickbox')) {
							return false;
						}
						return !kickboxPassedEmails[normalizeQuoteEmail($(element).val())];
					},
				}
			},
			phone: {
				required: true,
				phone: true,
				remote: {
					url: powerQuoteForm.ajaxurl,
					data: {
						action: 'power_validate_phone',
					},
					cache: false,
					beforeSend: function () {
						pqfmSetButtonsDisabled(true);
					},
					complete: function () {
						pqfmSetButtonsDisabled(false);
					},
				}
			},
			consent: {
				required: true,
			},
		},
		messages: {
			email: {
				email: function (params, element) {
					return containsEmoji($(element).val())
						? 'Please enter only letters.'
						: 'Please enter a valid email.';
				},
			},
			phone: {
				phone: 'Please enter a valid 10 digit phone number.',
			},
		},
		submitHandler: function () {
			if ($('#pqfm_no_coverage').is(':visible')) {
				return false;
			}

			// The modal stays up, spinner and all, until power_add_lead comes back
			$('#pqfm-submit').addClass('loading');

			// Same lead POST as the inline Request a Call path, but from
			// this form's fields - the page-1 inputs are left as they were.
			validatorDetails.settings.submitHandler.call(
				validatorDetails,
				$('#pqfm_form_details')[0]
			);

			return false;
		},
		invalidHandler: function (event, validator) {
			pqfTrackValidationError(validator.currentForm, validator, 'request_call');
			pqfmSetButtonsDisabled(false);
		},
		onfocusout: function (element) {
			if (zipFieldLookupRunning(element)) return;
			$(element).valid();
		},
		// Email: local format on input (below). Kickbox only on blur/submit
		// unless this address already passed in this tab.
		onkeyup: function (element, event) {
			if ('pqfm_email' === element.id) {
				return;
			}
			if (zipFieldLookupRunning(element)) return;
			$.validator.defaults.onkeyup.call(this, element, event);
		},
	});

	$('#pqfm_email').on('input', function () {
		recheckEmailWithoutKickbox(this, validatorModal);
	});


	$(document).ready(function () {
		enableButtons();

		if (!handleRedirectWorkflow()) {
			$('.pqf-page-1').show();
			if ($('#pqf_no_coverage').is(':visible') || ($.trim($('#pqf_zip_code').val()) && !zipFieldHasProducts())) {
				if ($('#pqf_no_coverage').is(':visible')) {
					$('.pqf-page-1.pqf-callout').hide();
				} else {
					restoreZipProductsIfNeeded();
				}
			}
		}

		$(window).on('pageshow.pqfZipRestore', function (event) {
			if (event.originalEvent && event.originalEvent.persisted) {
				restoreZipProductsIfNeeded();
			}
		});

		$(window).off('resize.pqfSlider').on('resize.pqfSlider', function () {
			initSlider();
		});

		$(window).off('resize.pqfSideImages').on('resize.pqfSideImages', function () {
			refreshSideImagesForViewport();
		});

		$('#pqf_wrap').on('change', '.pqf-product input', function () {
			var $this = $(this);
			var $product = $this.parents('.pqf-product');
			if ($this.prop('checked')) $product.addClass('pqf-product--selected');
			else $product.removeClass('pqf-product--selected');
		});

		$('#pqf_wrap').on('change', '#pqf_phone', function () {
			var $this = $(this);
			var val = $this.val();
			if (!isValidPhone(val)) return;
			setTimeout(function () {
				$this.val(formatPhone(val));
			}, 0);
		});

		$('#pqf_wrap').on('click', '#pqf_day_list .pqf-swiper-slide', function () {
			var $this = $('input', this);
			if ($this.prop('disabled')) return;
			if ($this.val() === $('#pqf_day_list').data('day')) return;
			setTimeSlots($this.val());
			$this.prop('checked', true);
			$('#day-error').empty();
		});

		$('#pqf_wrap').on('click', '.pqf-page-4 .pqf-button', function () {
			// GA4 : "Yes" to scheduling from the request-a-call
			// thank-you screen - re-entry into the schedule-online path.
			pqfPushEvent('free_quote_schedule_online_click', {
				form_step: 'thank_you',
				contact_path: 'schedule'
			});

			lockAddressZip();
			cache.form1.call_later = 1;
			$('#scheduled_self_set').val(cache.form1.call_later);
			setErrMsg(2);
			setSideImage('#side-img', 'step2');
			$('.pqf-page-4').hide();
			$('.pqf-page-2').show();
			loadAddressAutocomplete(initAddressAutoComplete);
			setTimeout(function () {
				scrollTop();
			}, 0);
		});

		$('#pqf_wrap').on('click', '#pqf_zip_code_field .pqf-button-retry', function () {
			$('#pqf_zip_code-error').empty();
			var $input = $('#pqf_zip_code');
			var pv = $input.data('previousValue');
			if (!pv) return;
			pv.old = '';
			validatorDetails.element('#pqf_zip_code');
			return false;
		});

		$('#pqf_wrap').on('click', '#pqf_email_field .pqf-button-retry', function () {
			$('#pqf_email-error').empty();
			var $input = $('#pqf_email');
			var pv = $input.data('previousValue');
			if (!pv) return;
			pv.old = '';
			validatorDetails.element('#pqf_email');
			return false;
		});

		$('#pqf_wrap').on('click', '#pqf_phone_field .pqf-button-retry', function () {
			$('#pqf_phone-error').empty();
			var $input = $('#pqf_phone');
			var pv = $input.data('previousValue');
			if (!pv) return;
			pv.old = '';
			validatorDetails.element('#pqf_phone');
			return false;
		});

		$('#pqf_wrap').on('click', '.pqf-page-1 .pqf-actions .pqf-button', function () {
			var btn = this;
			$('.pqf-page-1 .pqf-actions .pqf-button').each(function (idx) {
				if (this === btn) cache.clickedBtnId = idx;
			});

			// GA4: contact-path choice. idx 0 is "Schedule
			// Online" (#next-step-1), idx 1 is "Request a Call"
			// (#submit-form). Fires on click, before validation/submit,
			// per the "clicks record intent" rule - this records the
			// choice even if the form doesn't end up submitting.
			pqfPushEvent(
				0 === cache.clickedBtnId ? 'free_quote_schedule_online_click' : 'free_quote_request_call_click',
				{ form_step: 'details' }
			);
		});

		$('#pqf_wrap').on('mousedown', '[data-pqfm-close]', function (e) {
			e.preventDefault();
			pqfmClose();
		});

		$('#pqf_wrap').on('input', '#pqfm_zip_code', function () {
			if ($.trim($(this).val()) === cache.pqfmZipShown) return;
			pqfmClearZipResult();
		});

		var pqfmZipTimeout = null;
		$('#pqf_wrap').on('keyup', '#pqfm_zip_code', function () {
			var currentZip = $.trim(this.value);
			if (currentZip !== cache.pqfmZipRendered) {
				cache.pqfmZipRendered = '';
			}
			clearTimeout(pqfmZipTimeout);
			var $this = $(this);
			pqfmZipTimeout = setTimeout(function () {
				if (!$('#pqfm_no_coverage').filter(':visible').length) {
					return;
				}
				if (!$this.hasClass('error')) {
					return;
				}
				pqfmShowCoverage(true);
				$('.pqfm-products-label').hide();
				$('.pqfm-products').empty();
				pqfmZipDesc().empty();
				cache.pqfmZipShown = '';
			}, 300);
		});

		$('#pqf_wrap').on('change', '#pqfm_phone', function () {
			var $this = $(this);
			var val = $this.val();
			if (!isValidPhone(val)) return;
			setTimeout(function () {
				$this.val(formatPhone(val));
			}, 0);
		});

		$(document).off('keydown.pqfm').on('keydown.pqfm', function (e) {
			if (!pqfmIsOpen()) return;

			if ('Escape' === e.key || 'Esc' === e.key || 27 === e.which) {
				pqfmClose();
				return;
			}

			if ('Tab' === e.key || 9 === e.which) pqfmHandleTab(e);
		});

		$('#pqf_wrap').on('submit', '#pqfm_form_details', function (e) {
			e.preventDefault();
		});

		$('#pqf_wrap').on('input', EMOJI_FIELDS, function () {
			var $field = $(this);
			var validator = $field.closest('form').data('validator');
			if (!validator) return;

			var hasEmoji = containsEmoji($field.val());
			if (!hasEmoji && !$field.data('fieldHasEmoji')) return;

			$field.data('fieldHasEmoji', hasEmoji);
			validator.element(this);
		});

		var timeout = null;
		$('#pqf_wrap').on('keyup', '#pqf_zip_code', function () {
			isZipFilled = false;
			var currentZip = $.trim(this.value);
			if (currentZip !== cache.pqfZipRendered) {
				cache.pqfZipRendered = '';
			}
			clearTimeout(timeout);
			var $this = $(this);
			timeout = setTimeout(function () {
				var isNoCoverage = $('#pqf_no_coverage').filter(':visible').length;
				if (isNoCoverage) {
					if ($this.hasClass('error')) {
						showHideNoCovergeView(true);
						$('.pqf-products-label').hide();
						$('.pqf-products').empty();
						setZipConfirm('');
					}
				}
				else {
					var pv = $this.data('previousValue');
					if (!pv) return;
					// A blur already sent this zip; re-validating now would
					// abort that request and refetch the same products.
					if (validatorDetails.pending[$this[0].name]) return;
					if (zipLookupRunning('page1', $.trim($this.val()))) return;
					if (pv.old.indexOf('data=' + $this.val()) === 0) {
						pv.old = '';
						validatorDetails.element($this[0]);
					}
				}
			}, 300);
		});

		if (!cache.redirectMode) {
			if (isZipFilled) {
				cache.lastProductsDesc = $('#pqf_zip_confirm').text();
			}
		}
	});

	function ucFirst(str) {
		return str
			.split(' ')
			.map(function (word) {
				return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
			})
			.join(' ');
	}
	function padZero(num) {
		return num < 10 ? '0' + num : num;
	}
	function to12HourFormat(time24) {
		var timeParts = time24.split(":");
		var hours = parseInt(timeParts[0], 10);
		var minutes = timeParts[1];
		var period = "AM";

		if (hours >= 12) {
			period = "PM";
		}
		if (hours > 12) {
			hours -= 12;
		}
		if (hours === 0) {
			hours = 12;
		}

		return hours + ":" + minutes + " " + period;
	}
	function toMonthNumber(dateStr) {
		var monthMap = {
			"january": 1,
			"february": 2,
			"march": 3,
			"april": 4,
			"may": 5,
			"june": 6,
			"july": 7,
			"august": 8,
			"september": 9,
			"october": 10,
			"november": 11,
			"december": 12
		};
		var cleanedDateStr = dateStr.toLowerCase().replace("today, ", "").replace("today", "").trim();
		var dateParts = cleanedDateStr.match(/([a-z]+)\s*\d+/);
		if (dateParts) {
			var monthName = dateParts[1];
			return monthMap[monthName];
		}
		return null;
	}
	function getDefaultScheduleDay(days) {
		var firstAvailableDay = '';
		var todayDay = '';

		$.each(days, function (idx, day) {
			if (!day.available) return;
			if (!firstAvailableDay) firstAvailableDay = day.key;

			if (isScheduleDateToday(day)) {
				todayDay = day.key;
				return false;
			}
		});

		return todayDay || firstAvailableDay || (days[0] ? days[0].key : '');
	}
	function isScheduleDateToday(day) {
		if (!day) return false;

		var formattedDate = $.trim(day.formattedDate || '').toLowerCase();
		if (formattedDate.indexOf('today') === 0) return true;

		var today = new Date();
		return Number(day.month) === today.getMonth() + 1 &&
			Number(day.monthDay) === today.getDate() &&
			Number(day.year) === today.getFullYear();
	}
	function selectScheduleDay(day) {
		setTimeSlots(day);
		$('#pqf_day_list input[name="day"]').filter(function () {
			return $(this).val() === day || Number($(this).val()) === Number(day);
		}).prop('checked', true);
	}
	function getYearFromMonths(month1, month2) {
		var currentDate = new Date();
		var currentYear = currentDate.getFullYear();
		var currentYearShort = currentYear % 100;

		if (!month1) {
			return currentYearShort;
		}

		if (month2 < month1) {
			return (currentYear + 1) % 100;
		}

		return currentYearShort;
	}
	function getAPIDate(dayKey) {
		var days = cache.schedule.arrDays;
		for (var i = 0; i < days.length; i++) {
			if (days[i].key === dayKey) {
				var mn2 = days[i].month;
				var year = days[i].year;
				return padZero(mn2) + "/" + padZero(dayKey) + "/" + (year % 100);
			}
		}
	}
	function isToday(day) {
		var fmtDt = $.trim(cache.schedule.days[day].formattedDate);
		return fmtDt.toLowerCase().indexOf('today') === 0;
	}
	function lowercaseFirstChar(str) {
		if (str.length === 0) return str;
		return str.charAt(0).toLowerCase() + str.slice(1);
	}
	function getTimeDesc(day) {
		var desc = 'Showing available times for ';
		var prevDay = day - 1;
		if (cache.schedule.days[prevDay] && isToday(prevDay)) {
			desc += 'tomorrow, ' + cache.schedule.days[day].formattedDate;
		}
		else if (isToday(day)) {
			desc += lowercaseFirstChar(cache.schedule.days[day].formattedDate);
		}
		else {
			desc += cache.schedule.days[day].formattedDate;
		}
		return desc;
	}
	function buildDayHTML(idx, obj) {
		var id = 'pqf_day_' + idx;
		return '<div class="pqf-swiper-slide" data-available="' + obj.available + '" data-idx="' + idx + '">' +
			'<div for="' + id + '">' + obj.weekDay +
			'<input ' + (obj.available ? '' : 'disabled') + ' type="radio" id="' + id + '" class="date-check" name="day" value="' + obj.key + '">' +
			'<div class="date-text">' + padZero(obj.monthDay) + '</div>' +
			'</div>';
	}
	function setTimeSlots(day) {
		var $list = $('#pqf_time_list .row').empty();
		var timeSlots = cache.schedule.timeSlots[day];
		$.each(timeSlots, function (idx, v) {
			$list.append(buildTimeHTML(idx, v));
		});
		$('#pqf_day_list').data('day', day);
		$('#pqf_time_desc').html(getTimeDesc(day));
	}
	function buildTimeHTML(idx, obj) {
		var id = 'pqf_time_' + idx;
		return '<div class="col-6 col-sm-4 col-md-3" data-available="' + obj.available + '">' +
			'<input ' + (obj.available ? '' : 'disabled') + ' type="radio" id="' + id + '" class="time-check" name="time" value="' + obj.time + '">' +
			'<label class="time-label" for="' + id + '">' + to12HourFormat(obj.time) +
			'</div>';
	}
	function getFormObj(formId) {
		var formObj = {};
		var inputs = $('#' + formId).serializeArray();
		$.each(inputs, function (i, input) {
			var n = input.name;
			if (-1 !== n.indexOf('[]')) {
				n = n.replace('[]', '');
				formObj[n] = formObj[n] || [];
				formObj[n].push(input.value)
			}
			else formObj[n] = input.value;
		});
		return formObj;
	}

	function showAjaxError(name, msg, pv) {
		if (!pv) return;
		// GA4 : AJAX-level failure on a field-level remote check
		// (ZIP lookup or email validation) - a server/transport error, not
		// a normal field validation rejection.
		pqfPushEvent('free_quote_form_error', {
			form_step: 'details',
			error_type: name + '_lookup_failed'
		});
		pqfReportQuoteFormError({
			form_step: 'details',
			error_type: name + '_lookup_failed',
			message: msg
		});
		validatorDetails.invalid[name] = true;
		var o = {};
		o[name] = msg;
		validatorDetails.showErrors(o);
		pv.message = msg;
		pv.valid = false;
	}

	var errMsgs = [
		'Submission failed. Please try again',
		'The phone number you provided does not appear to be correct. Please fix it and try again.',
		'AJAX request aborted. Please try again.',
	];

	// This is the active setErrMsg() - the earlier declaration of the same
	// name above is shadowed by this one (see the NOTE at that earlier
	// declaration). This function is the single place every page's
	// server/API-level failure passes through, so it's the one spot the
	// GA4 free_quote_form_error push needs to live for those
	// failures to be caught consistently.
	function setErrMsg(pageId, msg, details) {
		var $errDiv = $('.pqf-error', '.pqf-page-' + pageId).empty();
		if (undefined === msg) return;

		// GA4 : a real error message is being displayed to the
		// visitor on this page - track it once here rather than at every
		// call site. Guarded above by "if (undefined === msg) return;" so
		// the plain setErrMsg(pageId) calls used to clear the error div
		// between attempts never fire this.
		pqfPushEvent('free_quote_form_error', {
			form_step: pqfFormStepForPage(pageId),
			error_type: 'api_error'
		});

		if (pageId === 3 && cache.redirectMode && (msg !== undefined)) {
			if (typeof details === 'string' && details.includes('contact support')) {
				showScheduleError(details);
				pqfReportQuoteFormError({
					form_step: pqfFormStepForPage(pageId),
					error_type: pqfNrErrorType(msg, details),
					message: details
				});
				return;
			}
		}

		var msgIndex = msg;
		msg = 'string' === typeof msg ? msg : errMsgs[msg];
		$errDiv.append($('<div>').html(msg));
		var details = details
			? ('string' === typeof details ? details : errMsgs[details])
			: '';
		pqfReportQuoteFormError({
			form_step: pqfFormStepForPage(pageId),
			error_type: pqfNrErrorType(msgIndex, details || msg),
			message: details ? (msg + ' ' + details) : msg
		});
		if (details) {
			$errDiv.append($('<div>').append(details));
		}
		else $errDiv.append($('<div>'));
	}
	function processPageResponse(obj, pageId, okStatus, apiName) {
		okStatus = okStatus || 200;
		apiName = apiName ? (ucFirst(apiName) + ' ') : '';

		function simplifyErrorMessage(message) {
			if (!message) return message;
			if (message.includes('cURL error 28')) {
				return 'Submission failed. Please try again.';
			}
			return message;
		}

		if (!obj.success) {
			return setErrMsg(pageId, 0, simplifyErrorMessage(obj.data));
		}

		if (obj.data && obj.data[5] === 'duplicate_continue') {
			return true;
		}

		var statusCode = obj.data[0];
		var responseBody = obj.data[1];

		if (pageId === 3) {
			if (statusCode === 204 || statusCode === 200 || statusCode === 201) {
				return true;
			}
		} else {
			if (statusCode === 404 && 'Schedule ' === apiName) {
				return setErrMsg(pageId, '', 'We couldn\u2019t find that address. Check for typos and try again, or call us at 888-736-6335 for help.');
			}

			// For all other pages, proceed with the original logic
			if (okStatus !== statusCode && 422 !== statusCode) {
				return setErrMsg(pageId, 0, apiName + 'API aborted with ' + statusCode + ' response.');
			}
		}

		try {
			var o;
			if (typeof responseBody === 'string') {
				o = JSON.parse(responseBody);
			} else {
				o = responseBody;
			}

			if (422 === statusCode) {
				if (o.errors && o.errors['phone_primary']) {
					return setErrMsg(pageId, 1);
				}

				if (o.errors && o.errors['lead_source_id']) {
					var duplicateMessage = o.errors['lead_source_id'][0] || '';

					// Allow these duplicate responses to continue to scheduling.
					if (
						duplicateMessage === 'Duplicate Appointment Source Found' ||
						duplicateMessage === 'Duplicate: Active Lead'
					) {
						return true;
					}

					// Block if there is already an active appointment.
					if (duplicateMessage === 'Duplicate: Active Appointment') {
						return setErrMsg(
							pageId,
							'',
							'You already have an active appointment. Please contact us if you need to make changes to your appointment.'
						);
					}

					// Block if there is already an active project.
					if (duplicateMessage === 'Duplicate: Active Project') {
						return setErrMsg(
							pageId,
							'',
							"Look out for POWER's call, a scheduling specialist will be in touch shortly."
						);
					}

					// Keep the existing generic error for any other duplicate response.
					return setErrMsg(
						pageId,
						0,
						apiName + 'API returned error response. ' + duplicateMessage
					);
				}

				return setErrMsg(
					pageId,
					0,
					apiName + 'API returned error response. ' + simplifyErrorMessage(responseBody)
				);
			}
			return o;
		} catch (e) {
			return setErrMsg(
				pageId,
				0,
				'Failed to parse API\'s response. ' + simplifyErrorMessage(responseBody)
			);
		}
	}
	function isArray(arg) {
		return Object.prototype.toString.call(arg) === '[object Array]';
	}
	function showHideNoCovergeView(f) {
		var func = f ? 'show' : 'hide';
		var invFunc = f ? 'hide' : 'show';
		jQuery('.row', '#step-1')[func]();
		$('#pqf_no_coverage')[invFunc]();
		$('.pqf-page-1.pqf-callout')[func]();
	}
	function scrollTop() {
		setTimeout(function () {
			var h = jQuery('#wpadminbar').height()
			$('html,body').animate({
				scrollTop: $('#pqf_wrap').position().top - (h ? h : 0)
			}, 100);
		}, 0);
	}

	var __assign = (this && this.__assign) || function () {
		__assign = Object.assign || function (t) {
			for (var s, i = 1, n = arguments.length; i < n; i++) {
				s = arguments[i];
				for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
					t[p] = s[p];
			}
			return t;
		};
		return __assign.apply(this, arguments);
	};
	function doAjax(args, onSuccess, onFail, onFinally) {
		var url = args.url || powerQuoteForm.ajaxurl;

		return $.ajax(url, __assign({ type: "GET", dataType: "json" }, args))
			.done(function (data, textStatus, jqXHR) {
				onSuccess && onSuccess(data);
			})
			.fail(function (jqXHR, textStatus, errorThrown) {
				onFail && onFail(getAjaxFailReason(jqXHR, textStatus));
			})
			.always(function () {
				onFinally && onFinally();
			});
	}

	function getAjaxFailReason(x, exception) {
		var message;
		var statusErrorMap = {
			0: "Not connected.Please verify your network connection.",
			400: "Server understood the request, but request content was invalid.",
			401: "Unauthorized access.",
			403: "Forbidden resource can't be accessed.",
			500: "Internal server error.",
			503: "Service unavailable.",
		};
		if (x && "undefined" !== typeof x.status && exception !== "abort") {
			message = statusErrorMap[x.status];
		}
		if (!message) {
			if (exception === "parsererror") {
				message = "Parsing JSON failed";
			} else if (exception === "timeout") {
				message = "Request Timed out";
			} else if (exception === "abort") {
				message = "Request aborted";
			} else {
				message = "Ajax Error " + x.status;
			}
		}
		return message;
	}

	function isValidZipCode(zipCode) {
		return /(^\d{5}$)|(^\d{5}-\d{4}$)/.test(zipCode);
	}
	function isValidPhone(phone) {
		return /^[\d\(\)\-\s]*$/.test(phone) && 10 === phone.replace(/\D/g, '').length;
	}
	function formatPhone(phone) {
		var d = phone.replace(/\D/g, '');
		return '(' + d.substring(0, 3) + ') ' + d.substring(3, 6) + '-' + d.substring(6);
	}


	if (!getUrlParameter('appointment_id') && !getUrlParameter('plead_id')) {
		setSideImage('#side-img', 'step1', { fetchpriority: 'high', loading: 'eager', decoding: 'sync' });
	}
	var isZipFilled = $.trim($('#pqf_zip_code').val()) && zipFieldHasProducts();

	if (isZipFilled) {
	cache.pqfZipServerRendered = $.trim($('#pqf_zip_code').val());
	cache.pqfZipRendered = cache.pqfZipServerRendered;
	var serverZipLabel = $('.pqf-zip-location').data('label') || $('#pqf_zip_confirm').text();
	rememberZipState(cache.pqfZipServerRendered, serverZipLabel);
	// The server already validated this zip for the page, so it counts as
	// checked this session: rebuild the lookup response (location label +
	// products markup) and cache it, so neither form asks for it again.
	if (!zipProductsCache.hasOwnProperty(cache.pqfZipServerRendered)) {
		rememberZipProducts(
			cache.pqfZipServerRendered,
			$('<div>').append(
				$('<span class="pqf-zip-location">').attr('data-label', $.trim(serverZipLabel || ''))
			).html() + $('.pqf-products').html()
		);
	}
	}

	function initSlider() {
		var $sliderWrap = $('.pqf-slider-wrapper');
		var $container = $('.pqf-swiper-container');
		var $wrapper = $('.pqf-swiper-wrapper');
		var $slides = $('.pqf-swiper-slide');
		var $prev = $('.pqf-slider-prev');
		var $next = $('.pqf-slider-next');

		var slideWidth = $slides.eq(0).outerWidth();
		var gap = parseInt($wrapper.css('gap')) || 0;
		var totalSlideWidth = slideWidth + gap;

		var currentIndex = 0;

		function calculateSlidesPerView() {
			var containerWidth = $sliderWrap.innerWidth() - 60;
			return Math.floor((containerWidth + gap) / totalSlideWidth);
		}

		function updateControls(slidesPerView) {
			var totalSlides = $slides.length;
			var maxIndex = totalSlides - slidesPerView;

			if (currentIndex <= 0) {
				$prev.addClass('pqf-hidden');
			} else {
				$prev.removeClass('pqf-hidden');
			}

			if (currentIndex >= maxIndex) {
				$next.addClass('pqf-hidden');
			} else {
				$next.removeClass('pqf-hidden');
			}
		}

		function moveTo(index, slidesPerView) {
			var totalSlides = $slides.length;
			var maxIndex = totalSlides - slidesPerView;

			if (index < 0) index = 0;
			if (index > maxIndex) index = maxIndex;

			currentIndex = index;
			var translateX = -currentIndex * totalSlideWidth;

			$wrapper.css('transform', 'translateX(' + translateX + 'px)');
			updateControls(slidesPerView);
		}

		function init() {
			var slidesPerView = calculateSlidesPerView();
			var totalSlides = $slides.length;
			$sliderWrap.removeClass('pqf-no-slider');

			if (totalSlides <= slidesPerView) {
				$sliderWrap.addClass('pqf-no-slider');
				return;
			}
			moveTo(currentIndex, slidesPerView);

			$prev.off('click').on('click', function () {
				moveTo(currentIndex - 1, slidesPerView);
			});

			$next.off('click').on('click', function () {
				moveTo(currentIndex + 1, slidesPerView);
			});

		}

		init();
	}

	function getVersionedAssetUrl(url, version) {
		if (!url) return '';
		if (!version) return url;
		return url + (url.indexOf('?') === -1 ? '?' : '&') + 'ver=' + encodeURIComponent(version);
	}

	function getAddressAutocompleteConfig() {
		return powerQuoteForm.autocomplete || {};
	}

	function logAddressAutocompleteWarning(message) {
		if (window.console && console.warn) {
			console.warn(message);
		}
	}

	function loadAddressAutocompleteStyle(config) {
		var styleUrl = getVersionedAssetUrl(config.style_url, config.style_version);
		var styleId = config.style_id || 'pqf-jquery-ui-autocomplete-css';

		if (!styleUrl || document.getElementById(styleId)) return;

		var link = document.createElement('link');
		link.id = styleId;
		link.rel = 'stylesheet';
		link.href = styleUrl;
		(document.head || document.getElementsByTagName('head')[0]).appendChild(link);
	}

	function isAddressAutocompleteReady() {
		return !!($.ui && $.ui.autocomplete && $.fn.autocomplete);
	}

	function flushAddressAutocompleteCallbacks() {
		var callbacks = cache.addressAutocompleteCallbacks || [];
		cache.addressAutocompleteCallbacks = [];

		$.each(callbacks, function (idx, callback) {
			if ('function' === typeof callback) callback();
		});
	}

	function loadAddressAutocomplete(callback) {
		var config = getAddressAutocompleteConfig();
		var scriptId = config.script_id || 'pqf-jquery-ui-autocomplete-js';
		var scriptUrl = getVersionedAssetUrl(config.script_url, config.script_version);

		loadAddressAutocompleteStyle(config);

		if (isAddressAutocompleteReady()) {
			if (callback) callback();
			return;
		}

		if (callback) {
			cache.addressAutocompleteCallbacks = cache.addressAutocompleteCallbacks || [];
			cache.addressAutocompleteCallbacks.push(callback);
		}

		if (cache.addressAutocompleteLoading) return;

		if (!scriptUrl) {
			cache.addressAutocompleteCallbacks = [];
			logAddressAutocompleteWarning('Address autocomplete asset URL is unavailable.');
			return;
		}

		cache.addressAutocompleteLoading = true;

		function handleLoad() {
			cache.addressAutocompleteLoading = false;

			if (isAddressAutocompleteReady()) {
				flushAddressAutocompleteCallbacks();
			} else {
				cache.addressAutocompleteCallbacks = [];
				logAddressAutocompleteWarning('Address autocomplete script loaded, but autocomplete is unavailable.');
			}
		}

		function handleError() {
			cache.addressAutocompleteLoading = false;
			cache.addressAutocompleteCallbacks = [];
			logAddressAutocompleteWarning('Address autocomplete script failed to load.');
		}

		var existingScript = document.getElementById(scriptId);
		if (existingScript) {
			existingScript.parentNode.removeChild(existingScript);
		}

		var script = document.createElement('script');
		script.id = scriptId;
		script.src = scriptUrl;
		script.async = true;
		script.onload = handleLoad;
		script.onerror = handleError;
		(document.head || document.getElementsByTagName('head')[0]).appendChild(script);
	}

	function initAddressAutoComplete() {
		var $address = $("#pqf_street");
		var $city = $("#pqf_city");
		var $state = $("#pqf_state");
		var $zip_code_1 = $("#pqf_zip_code_1");

		if (!$address.length || 'function' !== typeof $address.autocomplete) return;
		if ($address.data('pqfAutocompleteReady') || $address.data('ui-autocomplete')) return;

		$address.data('pqfAutocompleteReady', true);

		$address.autocomplete({
			minLength: 2,
			source: function (request, response) {
				if (!isValidZipCode($zip_code_1.val())) return response([]);
				$.ajax({
					url: '/wp-json/custom/v1/address-lookup',
					method: "GET",
					data: {
						address: $.trim(request.term),
						zip_code: $zip_code_1.val()
					},
					success: function (data) {
						var formatted = $.map(data, function (item) {
							var v = $.trim(item.stree_address);
							return {
								label: v + ", " + $.trim(item.city) + ", " + $.trim(item.state) + " " + $.trim(item.zip),
								value: v,
								obj: item
							};
						});
						response(formatted);
					},
					error: function (xhr) {
						response([]);
					}
				});
			},
			select: function (event, ui) {
				var obj = ui.item.obj;
				$city.val($.trim(obj.city));
				if (!$state.prop('disabled') && !$state.prop('readonly')) {
					$state.val($.trim(obj.state));
				}
				$address.data('adrs_id', obj.id);
			},
			classes: {
				"ui-autocomplete": "pqf-ui-autocomplete"
			},
			open: function () {
				var menu = $(".ui-autocomplete");
				var offset = menu.offset();
				menu.offset({
					top: offset.top + 5
				});
				menu.scrollTop(0);
			}
		});

		$.ui.autocomplete.prototype._renderItem = function (ul, item) {
			var labelHtml = boldCommonWords(item.label, $.trim(this.term));
			var svgIcon =
				'<svg width="12" height="17" viewBox="0 0 12 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 0.75C8.81969 0.75 11.2499 3.34781 11.25 6.74121C11.25 7.49708 10.9371 8.47804 10.3906 9.58203C9.85265 10.6688 9.12708 11.799 8.38965 12.8311C7.65409 13.8605 6.9164 14.7776 6.3623 15.4385C6.23102 15.5951 6.10786 15.735 6 15.8604C5.89214 15.735 5.76898 15.5951 5.6377 15.4385C5.08361 14.7776 4.3459 13.8605 3.61035 12.8311C2.87292 11.799 2.14735 10.6687 1.60938 9.58203C1.06286 8.47802 0.75 7.49704 0.75 6.74121C0.750078 3.45368 3.03106 0.913152 5.7373 0.757812L6 0.75ZM6 4.52539C4.93668 4.52539 4.10744 5.4047 4.10742 6.44824C4.10742 7.49179 4.93667 8.37109 6 8.37109C7.06333 8.37109 7.89258 7.49179 7.89258 6.44824C7.89256 5.4047 7.06332 4.52539 6 4.52539Z" stroke="#102F48" stroke-width="1.5"/></svg>';

			return $("<li>")
				.append('<div>' + svgIcon + '<span>' + labelHtml + '<span></div>')
				.appendTo(ul);
		};

		function boldCommonWords(s1, s2) {
			var words1 = s1.split(/\b/);
			var words2 = s2.toLowerCase().split(/\s+/);
			var lookup = {};
			for (var i = 0; i < words2.length; i++) {
				lookup[words2[i]] = true;
			}
			for (var j = 0; j < words1.length; j++) {
				var wordLower = words1[j].toLowerCase();
				if (lookup[wordLower]) {
					words1[j] = '<b>' + words1[j] + '</b>';
				}
			}
			return words1.join('');
		}
	}

});
// end jQuery(function ($) { ... })

	} // end boot()

	if (typeof powerQuoteForm === 'undefined') {
		return failSafe('localize missing');
	}

	var fb = powerQuoteForm.fallback || {};

	function withValidate() {
		if (ready()) return boot();
		load(fb.validate, function (err) {
			if (err || !ready()) return failSafe('validate unavailable');
			boot();
		});
	}

	if (ready()) return boot();
	if (window.jQuery) return withValidate();

	load(fb.jquery, function (err) {
		if (err || !window.jQuery) return failSafe('jquery unavailable');
		withValidate();
	});
})();

function firePqfScheduleOnlineView() {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'schedule_online_page_view' });
}

/**
 * GA4 / GTM helpers.
 *
 * pqfPushEvent() is the one place every new custom event in this file goes
 * through - it always sets `event`, always initializes window.dataLayer,
 * and never sends name/email/phone/street (callers only ever pass the
 * approved parameter set: form_step, contact_path, service_area,
 * product_name, field_id, error_type).
 */
function pqfPushEvent(eventName, params) {
	window.dataLayer = window.dataLayer || [];
	var payload = { event: eventName };
	if (params) {
		for (var key in params) {
			if (Object.prototype.hasOwnProperty.call(params, key)) {
				payload[key] = params[key];
			}
		}
	}
	window.dataLayer.push(payload);
}

/**
 * New Relic custom event for quote form errors. Call alongside existing
 * free_quote_form_error GA4 pushes — does not change dataLayer behavior.
 */
function pqfReportQuoteFormError(attrs) {
	if (!window.newrelic || typeof window.newrelic.recordCustomEvent !== 'function') {
		return;
	}

	attrs = attrs || {};
	var message = attrs.message
		? String(attrs.message).replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim()
		: '';

	// Loading copy reuses setErrMsg(); do not treat it as an error in NR.
	if (/^loading\s/i.test(message)) {
		return;
	}

	var payload = {
		form_step: attrs.form_step || 'details',
		error_type: attrs.error_type || 'unknown',
		form_version: 'legacy'
	};

	if (message) {
		if (message.length > 240) {
			message = message.slice(0, 240);
		}
		payload.message = message;
	}

	window.newrelic.recordCustomEvent('QuoteFormError', payload);
}

/**
 * Narrower error_type for New Relic only. GA4 keeps its existing values.
 */
function pqfNrErrorType(msg, detailsText) {
	var text = ((typeof detailsText === 'string' ? detailsText : '') + ' ' +
		(typeof msg === 'string' ? msg : '')).toLowerCase();

	if (msg === 1 || text.indexOf('phone number') !== -1) {
		return 'validation_phone';
	}
	if (text.indexOf('find that address') !== -1) {
		return 'address_not_found';
	}
	if (text.indexOf('security token') !== -1) {
		return 'security_nonce';
	}
	if (text.indexOf('connection error') !== -1 || text.indexOf('request timed out') !== -1) {
		return 'network';
	}
	if (text.indexOf('lead information') !== -1) {
		return 'missing_plead_id';
	}
	if (text.indexOf('active appointment') !== -1) {
		return 'duplicate_active_appointment';
	}
	if (text.indexOf('active project') !== -1 || text.indexOf('scheduling specialist') !== -1) {
		return 'duplicate_active_project';
	}
	if (text.indexOf('no appointment slots') !== -1) {
		return 'schedule_no_slots';
	}
	if (text.indexOf('no appointment availability') !== -1) {
		return 'schedule_unavailable';
	}
	if (
		text.indexOf('failed to load appointment') !== -1 ||
		text.indexOf('unable to load appointment') !== -1
	) {
		return 'schedule_load_failed';
	}
	if (
		text.indexOf('no appointment data') !== -1 ||
		text.indexOf('invalid appointment') !== -1
	) {
		return 'schedule_data_invalid';
	}
	if (text.indexOf('server error occurred') !== -1) {
		return 'server_error';
	}
	if (text.indexOf('api aborted') !== -1 || text.indexOf('api returned error') !== -1) {
		return 'api_http_error';
	}
	if (text.indexOf('failed to parse') !== -1) {
		return 'api_parse_error';
	}
	if (msg === 2 || text.indexOf('ajax request aborted') !== -1) {
		return 'ajax_aborted';
	}
	if (msg === 0 || text.indexOf('submission failed') !== -1) {
		return 'submission_failed';
	}

	return 'api_error';
}

/**
 * Maps a pqf page number to the form_step parameter value used across the
 **/
function pqfFormStepForPage(pageId) {
	var map = {
		1: 'details',
		2: 'address',
		3: 'calendar',
		4: 'thank_you',
		5: 'booking_success'
	};
	return map[pageId] || 'details';
}

/**
 * Maps a pqf <form> element to the form_step parameter value
 */
function pqfFormStepForForm(form) {
	var formId = form && form.id ? form.id : '';
	var map = {
		pqf_form_details: 'details',
		pqf_form_address: 'address',
		pqf_form_schedule: 'calendar'
	};
	return map[formId] || 'details';
}

/**
 * Which surface a details-step event came from: the page-1 form, or the
 * Request a Call modal, whose ids are all prefixed pqfm_.
 */
function pqfFormVariantForForm(form) {
	var formId = form && form.id ? form.id : '';
	return 0 === formId.indexOf('pqfm_') ? 'modal' : 'inline';
}

/**
 * GA4: client-side field validation failure - one push per
 * failed submit attempt, from any of the three pqf forms' invalidHandler.
 */
function pqfTrackValidationError(form, validator, contactPath) {
	var errorMap = (validator && (validator.errorMap || validator.invalid)) || {};
	var errorFields = Object.keys(errorMap);
	var formStep = pqfFormStepForForm(form);

	var params = {
		form_step: formStep,
		error_count: validator && typeof validator.numberOfInvalids === 'function'
			? validator.numberOfInvalids()
			: errorFields.length,
		error_fields: errorFields.join(',')
	};

	if (formStep === 'details') {
		params.form_variant = pqfFormVariantForForm(form);
		if (contactPath) {
			params.contact_path = contactPath;
		}
	}

	pqfPushEvent('form_validation_error', params);
}
